<template>
  <div class="form-dashboard-container">
    <ContentContainerNavbar title="Dashboard" :searchBarPlaceholder="$t('i18n.searchBarPlaceholder')" :dateFilter="true"
      searchBar @date-range-input="handleDateRange" @search-input="handleFormSearch" />
    <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
    <div v-else class="stats-cards-container">
      <v-empty-state v-if="formList.length === 0" icon="mdi-magnify" :headline="$t('i18n.noForms')"
        :text="$t('i18n.noFormsText')" title=""></v-empty-state>
      <FormStatsCard v-for="form in filteredOrderedForms" :key="form.id" :form="form" :dateRange="dateRange" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ContentContainerNavbar from '../navbars/ContentContainerNavbar.vue'
import FormStatsCard from '../cards/FormStatsCard.vue'
import { Form, DateRange } from '@/utils/DataTypes'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import { api } from '@/utils/HelperFunctions'

export default defineComponent({
  name: 'StatisticsDashboard',
  setup () {
    const router = useRouter()
    const appStore = useAppStore()
    return {
      router,
      appStore
    }
  },
  components: {
    ContentContainerNavbar,
    FormStatsCard
  },
  async mounted () {
    await this.getFormList()
    this.loading = false
  },
  data () {
    return {
      formList: [] as Form[],
      searchFormQuery: '',
      dateRange: null as DateRange | null,
      loading: true
    }
  },
  methods: {
    async getFormList () {
      try {
        const url = '/forms-simplified'
        const getFormListResponse = await api(url, 'get')

        if (!getFormListResponse) return

        this.formList = getFormListResponse.data
      } catch (error) {
        this.appStore.addAlert('error', 'Couldn\'t get forms list.')
      }
    },
    navigate (routeName: string) {
      this.router.push({ name: routeName })
    },
    handleDateRange (newDateRange: DateRange | null) {
      if (newDateRange) {
        this.dateRange = newDateRange
      } else {
        this.dateRange = null
      }
      this.dateRange = newDateRange
    },
    handleFormSearch (searchQuery: string) {
      this.searchFormQuery = searchQuery
    }
  },
  provide () {
    return {
      dateRange: computed(() => this.dateRange)
    }
  },
  computed: {
    filteredOrderedForms (): Form[] {
      const searchQueryLower = this.searchFormQuery.toLowerCase()
      const filteredForms = this.formList
        .filter((form: Form) =>
          form.name.toLowerCase().includes(searchQueryLower)
        )
        .sort((a: Form, b: Form) => {
          if (a.id == null && b.id == null) return 0
          if (a.id == null) return 1
          if (b.id == null) return -1
          return b.id - a.id // DESC
        })
      return filteredForms
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.form-dashboard-container {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;

  box-shadow: 2px 0 15px 0 rgba(0, 0, 0, 0.08);

  .stats-cards-container {
    grid-row: 2;
    display: grid;
    gap: 1.0em;
    padding: 1.0em;
    grid-auto-rows: min-content;
    overflow-y: auto;

    .no-data-container {
      display: grid;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
